import React from 'react'

import AddClinicalHistoryAndRecordLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/AddClinicalHistoryAndRecord'

const AddClinicalHistoryAndRecord = () => <AddClinicalHistoryAndRecordLayout />

export default AddClinicalHistoryAndRecord
